/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 17:46:31
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-21 11:21:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentGateway/StripeItem.tsx
 */
import { Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default ({ handleResetInput, unlockEditable, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { uuid } = params;

  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='publishableKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.publishableKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.publishableKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.publishableKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('publishableKey')}
                  onEdit={() => handleResetInput('publishableKey')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='secreteKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.secretKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.secretKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.secretKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('secreteKey')}
                  onEdit={() => handleResetInput('secreteKey')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='signingKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.signingKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.signingKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.signingKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('signingKey')}
                  onEdit={() => handleResetInput('signingKey')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: '',
          },
        ]}
      />
    </Fragment>
  );
};
